import { QRCodeSVG } from "qrcode.react";

export const BrandedLabel = ({ title, code, sub, qrValue, footer, testid }) => (
  <div className="print-exact flex break-inside-avoid flex-col overflow-hidden rounded-md border-2 border-[#D4333B] bg-white text-black" data-testid={testid}>
    <div className="flex items-center justify-between gap-3 bg-[#D4333B] px-4 py-3">
      <img src="/brand/ep-group-white.png" alt="EP Group" className="h-8 w-auto" />
      <span className="text-right font-mono text-[10px] font-semibold uppercase leading-tight tracking-widest text-white">Compliance Pro</span>
    </div>
    <div className="flex flex-col items-center px-5 pb-4 pt-3 text-center">
      <p className="font-display text-2xl font-extrabold uppercase leading-tight">{title}</p>
      <p className="font-mono text-sm">{code}{sub ? ` - ${sub}` : ""}</p>
      <div className="my-3"><QRCodeSVG value={qrValue} size={170} level="M" /></div>
    </div>
    <div className="bg-[#2E3543] px-4 py-2 text-center text-xs font-semibold uppercase tracking-wider text-white">{footer}</div>
  </div>
);
